import script from "./TelegamSubscribe.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegamSubscribe.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__